export default "__VITE_ASSET__CIP7w7ai__"